import { Component, inject, output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PopoverDirective } from "@kno2/common/directives";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { DownloadsService } from "@kno2/data-access/downloads";
import { TOOLTIP_DOWNLOADS } from "../support.constants";

@Component({
    selector: "kno2-support-downloads",
    imports: [PopoverDirective],
    templateUrl: "./support.downloads.component.html"
})
export class SupportDownloadsComponent {
    private readonly route = inject(ActivatedRoute);
    private readonly downloadsService = inject(DownloadsService);
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    protected readonly baseUrl = this.appConfig.baseApiUrl;
    protected readonly tooltip = TOOLTIP_DOWNLOADS;
    protected readonly toggleCollapse = output<void>();

    protected expanded: boolean;
    protected downloads = this.downloadsService.getAll();

    public ngOnInit(): void {
        this.expanded = this.route.snapshot.routeConfig.path.endsWith("downloads");
    }
}
